import Intercom from '@intercom/messenger-js-sdk';

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('CookiebotOnConsentReady', function (event) {
    if (Cookiebot.consent.preferences) {
      const opts = {
        app_id: window.intercomAppId,
        region: 'eu',
      };
      if (window.intercomToken) {
        opts.intercom_user_jwt = window.intercomToken;
      }
      Intercom(opts);
    }
  });
});
